import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import RegisterMonthlyLayer from '../components/RegisterMonthlyLayer'

const RegisterMonthlyPage = () => {
  return (
    <MasterLayout>
        <Breadcrumb title='Register Monthly Payment' />
        <RegisterMonthlyLayer />
    </MasterLayout>
  )
}

export default RegisterMonthlyPage

